import {Layer,Box} from "grommet";

function LoadingLayer(){
    return(
        <Layer plain background="rgba(255,255,255,0.85)">
            <Box fill align="center" justify="center">
                <img
                    src="./images/LogoIcon.png"
                    alt="Caricamento"
                    style={{
                        width: 70,
                        height: 70,
                        animation: 'swingBounce 1.5s ease-in-out infinite'
                    }}
                />
                <style>{`
                    @keyframes swingBounce {
                        0%   { transform: rotate(0deg); }
                        55%  { transform: rotate(380deg); }
                        65%  { transform: rotate(350deg); }
                        72%  { transform: rotate(365deg); }
                        78%  { transform: rotate(358deg); }
                        82%  { transform: rotate(360deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </Box>
        </Layer>
    )
}

export default LoadingLayer;